module.exports = __webpack_public_path__ + "static/media/puzzle0203.568f6a3a.jpg";